module.exports = __webpack_public_path__ + "img/examendan.d8974af8.png";